import axios from 'axios';

const fetchDocument = async (entityName, path) => {
  try {
    const apiUrl =
      process.env.REACT_APP_ENV === 'test'
        ? 'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/test/get_document'
        : 'https://4b3ts82gua.execute-api.ap-south-1.amazonaws.com/prod/get_document';

    const res = await axios.get(apiUrl, {
      params: { entityName: entityName, key: path }
    });

    console.log(res);
    const response = await fetch(res.data.url);
    const arrayBuffer = await response.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer);
    return buffer; 
  } catch (error) {
    console.error(error);
    throw error; 
  }
};

export default fetchDocument;
